import { FC, useEffect, useState } from 'react'
import { OptionType } from '../../models/global.model';
import AppEditList from './app-edit-list';
import { deleteDemand, hideAndCreateNewDemand } from '../../services/demandsService';
import { ServiceQuotation } from '../../services/service-quotation';
import styles from './app-edit-demands.module.scss';
import { useTranslation } from 'react-i18next';

const AppEditDemands : FC = () => {
  const [demands, setDemands] = useState<OptionType[]>([]);
  const [loading, setLoading] = useState(true);
  const [t] = useTranslation('settings', { keyPrefix: 'editDemands'});

  useEffect(() => {
    (async () => {
      let allDemands = await ServiceQuotation.getDemands();
      allDemands = allDemands.map((d: { _id: string, name: string }) => ({ label: d.name, value: d._id }));
      setDemands(allDemands);
      setLoading(false);
    })();
  }, []);
  return <>
    <p className={styles.intro}>
      {t('intro', 'Här kan du ändra eller ta bort de skallkrav som föreslås när man skapar förfrågningsunderlag. Förändringar påverkar inte förfrågningsunderlag som redan är skapade.')}
    </p>
    <AppEditList
      listType="demands"
      list={demands ?? []}
      loading={loading}
      onChangeLabel={async (label, id) => {
        const created = await hideAndCreateNewDemand(label, id);
        setDemands(prev => {
          const index = prev.findIndex(p => p?.value === id);
          const updated = [...prev];
          updated[index] = { label: created.name, value: created._id };
          return updated;
        });
      }}
      onDelete={async (id) => {
        await deleteDemand(id);
        setDemands(prev => {
          const index = prev.findIndex(p => p?.value === id);
          const updated = [...prev];
          updated.splice(index, 1);
          return updated;
        })
      }}
    />
    </>;
}

export default AppEditDemands;
